module.exports = __webpack_public_path__ + "static/media/desktop11.198e15b2.png";